import { render } from "./Detail.vue?vue&type=template&id=2904a505&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=2904a505&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2904a505"

export default script